import DateHelper from 'src/app/helpers/date-helper';
import Employee from 'src/app/model/product/employee';
import { MultiplePlacerToursRequestObject } from '../../../employee-tour-list/employee-tour/service/employee-date-tour-controller-request.service';

export class TourPreviewSelectorModalHelper {
  private constructor() {}

  private static readonly DATE_FORMAT = 'yyyyMMdd';

  static convertToMultiplePlacerToursRequestObjects(
    selectorObjects: TourPreviewSelectorObject[]
  ): MultiplePlacerToursRequestObject[] {
    if (selectorObjects == null) {
      return null;
    }
    if (selectorObjects.length === 0) {
      return [];
    }

    const toReturn: MultiplePlacerToursRequestObject[] = [];

    selectorObjects.forEach(o => {
      if (o.placer == null) {
        return;
      }
      if (o.date1 != null) {
        toReturn.push({
          employeeId: o.placer.id,
          dateString: DateHelper.formatDate(o.date1, this.DATE_FORMAT)
        });
      }
      if (o.date2 != null) {
        toReturn.push({
          employeeId: o.placer.id,
          dateString: DateHelper.formatDate(o.date2, this.DATE_FORMAT)
        });
      }
      if (o.date3 != null) {
        toReturn.push({
          employeeId: o.placer.id,
          dateString: DateHelper.formatDate(o.date3, this.DATE_FORMAT)
        });
      }
    });

    return toReturn;
  }
}

export interface TourPreviewSelectorObject {
  placer?: Employee;
  date1?: Date;
  date2?: Date;
  date3?: Date;
}
